module.exports = "# Ian and Sara Intro\n\nYouTube: 4087d2dmtQY\n\n## Notes\nIntro to the Esmeralda and Goober Closing Story (0:31).\n\n# Esmeralda and Goober Closing Story\n\nYouTube: Bp6ewyFzUT8\n\n## Notes\nThe last installment of Esmeralda and Goober's adventures (1:40).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/60_esClosingStory/level6_closing.md
// module id = 1865
// module chunks = 2